import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import TabNavigations from '@src/components/TabNavigations';
import Header from '@src/components/Header';
import {
  NEW_FUNNEL_ROUTE,
  FUNNEL_EDIT_ROUTE,
  FUNNEL_MESSAGE_ROUTE,
  FUNNEL_APPLICATIONS_ROUTE,
  FUNNEL_REVIEW_ROUTE,
  FUNNEL_PITCH_ROUTE,
} from '@src/Routes/links';
import { MetricEventSource } from '@src/metrics/metrics.enum';
import {
  getActiveMetricsContext,
  trackViewCreateTargeting,
  trackViewCreateMessage,
  trackViewCreateApplication,
  trackViewCreateReview,
} from '@src/metrics';
import { idify } from '@src/util/idify';
import {
  isApplicationEnabled,
  isMessageEnabled,
  isPitchEnabled,
  isReviewEnabled,
  isTargetEnabled,
} from '../util/creationSteps';
import { Step } from './interfaces/step.interface';
import { FunnelHeaderProps } from './props';
import './styles.scss';

const STEPS: Step[] = [
  {
    getIsEnabled: isTargetEnabled,
    label: 'Target',
    name: 'target',
    onClick: (openingId, prevContext) =>
      trackViewCreateTargeting({
        'Event Source': MetricEventSource.TAB_NAVIGATION,
        'Opening Id': openingId,
        'Previous Context': prevContext,
      }),
    params: openingId => ({ openingId }),
    to: FUNNEL_EDIT_ROUTE,
  },
  {
    getIsEnabled: isMessageEnabled,
    label: 'Job opening',
    name: 'message',
    onClick: (openingId, prevContext) =>
      trackViewCreateMessage({
        'Event Source': MetricEventSource.TAB_NAVIGATION,
        'Opening Id': openingId,
        'Previous Context': prevContext,
      }),
    params: openingId => ({ openingId }),
    to: FUNNEL_MESSAGE_ROUTE,
  },
  {
    getIsEnabled: isApplicationEnabled,
    label: 'Application',
    name: 'application',
    onClick: (openingId, prevContext) =>
      trackViewCreateApplication({
        'Event Source': MetricEventSource.TAB_NAVIGATION,
        'Opening Id': openingId,
        'Previous Context': prevContext,
      }),
    params: openingId => ({ openingId }),
    to: FUNNEL_APPLICATIONS_ROUTE,
  },
  {
    getIsEnabled: isPitchEnabled,
    label: 'Pitch message',
    name: 'pitch',
    onClick: (openingId, prevContext) =>
      trackViewCreateApplication({
        'Event Source': MetricEventSource.TAB_NAVIGATION,
        'Opening Id': openingId,
        'Previous Context': prevContext,
      }),
    params: openingId => ({ openingId }),
    to: FUNNEL_PITCH_ROUTE,
  },
  {
    getIsEnabled: isReviewEnabled,
    label: 'Review & Publish',
    name: 'review',
    onClick: (openingId, prevContext) =>
      trackViewCreateReview({
        'Event Source': MetricEventSource.TAB_NAVIGATION,
        'Opening Id': openingId,
        'Previous Context': prevContext,
      }),
    params: openingId => ({ openingId }),
    to: FUNNEL_REVIEW_ROUTE,
  },
];

export const FunnelHeader: FC<FunnelHeaderProps> = ({ opening }) => {
  const location = useLocation();

  const pathname = location.pathname;

  const openingId = idify(opening);

  const stepsArray = STEPS.map(step => ({
    ...step,
    disabled: !opening || (!!opening && !step.getIsEnabled(opening)),
    onClick: () => step.onClick(openingId, getActiveMetricsContext(pathname)),
    params: step.params(openingId),
    to: !openingId && step.name === STEPS[0].name ? NEW_FUNNEL_ROUTE : step.to,
  }));

  return (
    <div className="funnel-header">
      <Header title="Post a job">
        <div className="funnel-header__nav">
          <TabNavigations numbered tabs={stepsArray} />
        </div>
      </Header>
    </div>
  );
};
